import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from './other.slice';
import axios from 'axios';

export const DashboardReq = createAsyncThunk('DashboardReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/dashboard`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const DashboardPartnerReq = createAsyncThunk('DashboardReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/partner/dashboard`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const DashboardInsuranceReq = createAsyncThunk('DashboardReq', async ({ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/insurance/dashboard`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})

export const allUsersReq = createAsyncThunk('allUsersReq', async ({ page, country, text },{ rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/users/list?page=${page}&country=${country}&text=${text}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        if (error?.response?.data?.error) {
            dispatch(toastError(error?.response?.data?.error))
        }
        return error;
    }
})


const initialState = {
    data: {},
    total: 0,
    pages: 0,
    users: [],
    current: 0,
    error: null,
    loading: false,
    uloading: false,
}

export const DashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(DashboardReq.pending, (state, action) => {
            state.loading = true
            state.data = {}
            return state
        })
        builder.addCase(DashboardReq.fulfilled, (state, action) => {
            state.loading = false
            state.data = action.payload.data
            return state
        })
        builder.addCase(DashboardReq.rejected, (state, action) => {
            state.loading = false
            state.data = {}
            state.error = 'Error occured'
        })
        builder.addCase(allUsersReq.pending, (state, action) => {
            state.uloading = true
            state.users = []
            state.total = 0
            state.pages = 0
            state.current = 0
            return state
        })
        builder.addCase(allUsersReq.fulfilled, (state, action) => {
            state.uloading = false
            state.users = action.payload.data?.users
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(allUsersReq.rejected, (state, action) => {
            state.uloading = false
            state.users = []
            state.total = 0
            state.pages = 0
            state.current = 0
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default DashboardSlice.reducer
